import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverline,
  SearchInput,
  SearchInputField,
  Flex,
  Text,
} from '@frontend/components';

import TitleBlock from 'components/DesignPrefabs/TitleBlock/TitleBlock';
import TitleBlockDescription from 'components/DesignPrefabs/TitleBlock/TitleBlockDescription';

import { getBusinessName } from 'store/session/selectors';

import { FooterContent, Form, FormWrapper } from './components';
import { featureFlagDrawer } from './data/actions';
import { getIsFeatureFlagDrawerOpen } from './data/reducer';

export const FeatureFlagDrawer = () => {
  const dispatch = useDispatch();

  const isOpen = useSelector(getIsFeatureFlagDrawerOpen);

  const userGroupBusinessName = useSelector(getBusinessName);

  const [searchTerm, setSearchTerm] = useState<string>('');
  const searchInputRef = useRef<HTMLInputElement | null>(null);

  const onClose = () => {
    setSearchTerm('');
    dispatch(featureFlagDrawer.close());
  };

  return isOpen ? (
    <Drawer
      onClose={onClose}
      isOpen={isOpen}
      size="lg"
      initialFocusRef={searchInputRef}
    >
      <DrawerContent maxW="48rem">
        <DrawerHeader
          display="flex"
          flexDirection="column"
          justifyContent="stretch"
          alignItems="stretch"
          pb={1.5}
          gap={1}
        >
          <Flex
            direction="row"
            alignItems="middle"
            justifyContent="space-between"
            gap={4}
            paddingRight={4.5}
          >
            <Flex direction="column" alignItems="flex-start">
              <DrawerOverline>{userGroupBusinessName}</DrawerOverline>
              <Text
                size="lg"
                fontWeight="heavy"
                whiteSpace="nowrap"
                color="interaction.superuser"
              >
                Edit Feature Flags
              </Text>
            </Flex>
            <SearchInput
              bg="page.surface"
              mode="live"
              onChange={(e) => setSearchTerm(e.target.value)}
              onClear={() => setSearchTerm('')}
              maxW="24rem"
              size="md"
              value={searchTerm}
            >
              <SearchInputField
                ref={searchInputRef}
                placeholder="Search feature flags"
              />
            </SearchInput>
          </Flex>
          {/* @ts-expect-error - TitleBlock is a JS component without proper TypeScript types */}
          <TitleBlock size="md">
            <TitleBlockDescription description="Configuration settings and features enabled for this user group. Note that the below tiers are our standard contract terms, but each deal is unique. Ensure you know what you are doing when changing a customer's flags." />
          </TitleBlock>
          <DrawerCloseButton />
        </DrawerHeader>
        <FormWrapper>
          <DrawerBody pt={0}>
            <Form searchTerm={searchTerm} />
          </DrawerBody>
          <DrawerFooter>
            <FooterContent closeDrawer={onClose} />
          </DrawerFooter>
        </FormWrapper>
      </DrawerContent>
    </Drawer>
  ) : null;
};
